/**
 * Unified Workflow Role Model
 * Defines global personas used across all QMS modules.
 */

// ─────────────────────────────────────────────────────────────────────
// Global Workflow Roles (match backend UserRole enum)
// ─────────────────────────────────────────────────────────────────────

export type WorkflowRole =
  | 'Admin'
  | 'QualityEngineer'
  | 'QualityInspector'
  | 'Inspector'
  | 'Supplier'
  | 'Manager'
  | 'Initiator'
  | 'DecisionOwner'
  | 'AssignedOwner'
  | 'Approver'
  | 'Customer';

// ─────────────────────────────────────────────────────────────────────
// Workflow Module identifiers
// ─────────────────────────────────────────────────────────────────────

export type WorkflowModule = 'OR' | 'NC' | 'CAPA' | 'Audit' | 'QRM';

// ─────────────────────────────────────────────────────────────────────
// API response types
// ─────────────────────────────────────────────────────────────────────

/** An action the current user is allowed to perform on a record */
export interface AllowedAction {
  actionName: string;
  toStatus: string;
}

/** Transition definition (from the /transitions endpoint) */
export interface WorkflowTransitionDef {
  fromStatus: string;
  toStatus: string;
  actionName: string;
  allowedRoles: string[];
}

/** Request payload to perform a transition */
export interface TransitionRequest {
  actionName: string;
  comments?: string;
}

/** Response from a successful transition */
export interface TransitionResult {
  fromStatus: string;
  toStatus: string;
  action: string;
}

// ─────────────────────────────────────────────────────────────────────
// Role metadata (for UI display)
// ─────────────────────────────────────────────────────────────────────

export const WORKFLOW_ROLE_LABELS: Record<WorkflowRole, string> = {
  Admin: 'Administrator',
  QualityEngineer: 'Quality Engineer',
  QualityInspector: 'Quality Inspector',
  Inspector: 'Inspector',
  Supplier: 'Supplier',
  Manager: 'Quality Manager',
  Initiator: 'Initiator / Observer',
  DecisionOwner: 'Decision Owner',
  AssignedOwner: 'Assigned Owner',
  Approver: 'Approver',
  Customer: 'Customer',
};

/** All roles available for admin role-switch dropdown */
export const ALL_WORKFLOW_ROLES: WorkflowRole[] = [
  'Admin', 'QualityEngineer', 'QualityInspector', 'Inspector',
  'Supplier', 'Manager', 'Initiator', 'DecisionOwner',
  'AssignedOwner', 'Approver', 'Customer',
];
